import { StackPanel } from "@accurx/design";
import styled from "styled-components";

export const StyledStackPanel = styled(StackPanel)`
    width: 100%;
`;
